import * as React from "react";
import { Component } from "react";
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
} from "react-bootstrap";
import "src/css/components/auth/registrationform.css";
import { IRegisterProps, IRegisterState } from "./interfaces";

export default class RegistrationForm extends Component<IRegisterProps, IRegisterState> {
  public constructor(props: IRegisterProps) {
    super(props);

    this.state = {
      loading: true,
      email: "",
      errors: [],
      firstName: "",
      lastName: "",
      password: "",
      password2: "",
      pwdState: null,
    };

    this.handleFirstNameChanged = this.handleFirstNameChanged.bind(this);
    this.handleLastNameChanged = this.handleLastNameChanged.bind(this);
    this.handleEmailChanged = this.handleEmailChanged.bind(this);
    this.handlePasswordChanged = this.handlePasswordChanged.bind(this);
    this.handlePassword2Changed = this.handlePassword2Changed.bind(this);

    this.getFirstNameValidationState = this.getFirstNameValidationState.bind(this);
    this.getLastNameValidationState = this.getLastNameValidationState.bind(this);
    this.getEmailValidationState = this.getEmailValidationState.bind(this);
    this.getPasswordValidationState = this.getPasswordValidationState.bind(this);
    this.getPassword2ValidationState = this.getPassword2ValidationState.bind(this);

    this.submitRegistration = this.submitRegistration.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    let pwdWeak: boolean = false;
    let pwdMedium: boolean = false;
    let pwdStrong: boolean = false;
    if (this.state.pwdState === "weak") {
      pwdWeak = true;
    } else if (this.state.pwdState === "medium") {
      pwdMedium = true;
    } else if (this.state.pwdState === "strong") {
      pwdStrong = true;
    }

    const labelSize = 4;
    const inputSize = 8;
    return (
      <Form onSubmit={this.submitRegistration} horizontal={true} id="registrationForm">
        <FormGroup controlId="firstName" validationState={this.getFirstNameValidationState()}>
          <Col componentClass={ControlLabel} sm={labelSize}>
            First Name
          </Col>
          <Col sm={inputSize}>
            <FormControl
              className="login-input"
              type="text"
              value={this.state.firstName}
              placeholder="First Name"
              onChange={this.handleFirstNameChanged}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
        <FormGroup controlId="lastName" validationState={this.getLastNameValidationState()}>
          <Col componentClass={ControlLabel} sm={labelSize}>
            Last Name
          </Col>
          <Col sm={inputSize}>
            <FormControl
              className="login-input"
              type="text"
              value={this.state.lastName}
              placeholder="Last Name"
              onChange={this.handleLastNameChanged}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
        <FormGroup controlId="registrationEmail" validationState={this.getEmailValidationState()}>
          <Col componentClass={ControlLabel} sm={labelSize}>
            Email
          </Col>
          <Col sm={inputSize}>
            <FormControl
              id="registrationEmail"
              className="login-input"
              type="email"
              value={this.state.email}
              placeholder="Enter Email"
              onChange={this.handleEmailChanged}
            />
            <FormControl.Feedback />
            <HelpBlock id="emailHelp">Enter in valid email address.</HelpBlock>
          </Col>
        </FormGroup>
        <FormGroup
          controlId="registrationPassword"
          validationState={this.getPasswordValidationState()}
        >
          <Col componentClass={ControlLabel} sm={labelSize}>
            Password
          </Col>
          <Col sm={inputSize}>
            <FormControl
              id="registrationPassword"
              className="login-input"
              type="password"
              value={this.state.password}
              placeholder="Password"
              onChange={this.handlePasswordChanged}
            />
            <FormControl.Feedback />
            <div className="password-state">
              <div className={"pwd pwd-weak " + (pwdWeak ? "show" : "")} />
              <div className={"pwd pwd-medium " + (pwdMedium ? "show" : "")} />
              <div className={"pwd pwd-strong " + (pwdStrong ? "show" : "")} />
            </div>
          </Col>
        </FormGroup>
        <FormGroup controlId="password2" validationState={this.getPassword2ValidationState()}>
          <Col componentClass={ControlLabel} sm={labelSize}>
            Verify Password
          </Col>
          <Col sm={inputSize}>
            <FormControl
              className="login-input"
              type="password"
              value={this.state.password2}
              placeholder="Password"
              onChange={this.handlePassword2Changed}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
        <FormGroup id="registerButton" className="btn-login">
          <Col smOffset={labelSize} sm={inputSize}>
            <Button className="login-btn" onClick={this.submitRegistration}>
              Register
            </Button>
          </Col>
        </FormGroup>
      </Form>
    );
  }

  private submitRegistration(e: any) {
    e.preventDefault();

    const firstNameValidation = this.getFirstNameValidationState();
    const lastNameValidation = this.getLastNameValidationState();
    const emailValidation = this.getEmailValidationState();
    const pwd1 = this.getPasswordValidationState();
    const pwd2 = this.getPassword2ValidationState();

    if (firstNameValidation === "success") {
      if (lastNameValidation === "success") {
        if (emailValidation === "success") {
          if (pwd1 !== "error" && pwd2 === "success") {
            const { appService } = this.props;
            appService
              .register(this.state.email, this.state.password)
              .then(userCredentials => {
                appService.setLoadStatus(true);
                this.props.setUser(userCredentials.user, this.state.firstName, this.state.lastName);
              })
              .then(() => {
                appService.login(this.state.email, this.state.password).then(userCredential => {
                  this.props.setUser(userCredential);
                });
              });
          }
        }
      }
    }
  }

  private getFirstNameValidationState() {
    const length = this.state.firstName.length;
    if (length > 1) {
      return "success";
    } else if (length > 0) {
      return "error";
    }
    return null;
  }
  private getLastNameValidationState() {
    const length = this.state.lastName.length;
    if (length > 1) {
      return "success";
    } else if (length > 0) {
      return "error";
    }
    return null;
  }
  private getEmailValidationState() {
    const length = this.state.email.length;
    if (length === 0) {
      return null;
    }
    if (this.state.email.indexOf("@") !== -1) {
      return "success";
    } else if (this.state.email.indexOf("@") === -1) {
      return "error";
    }
    return null;
  }
  private getPasswordValidationState() {
    const length = this.state.password.length;
    if (length === 0) {
      return null;
    }
    let pwdState = "weak";
    if (length > 12) {
      pwdState = "strong";
    } else if (length > 8) {
      pwdState = "medium";
    }
    if (pwdState === "weak") {
      return "error";
    } else if (pwdState === "medium") {
      return "warning";
    } else {
      return "success";
    }
  }
  private getPassword2ValidationState() {
    if (this.state.password !== "") {
      if (this.state.password !== this.state.password2) {
        return "error";
      } else {
        return "success";
      }
    }
    return null;
  }
  private handleFirstNameChanged(e: any) {
    this.setState({ firstName: e.target.value });
  }
  private handleLastNameChanged(e: any) {
    this.setState({ lastName: e.target.value });
  }
  private handleEmailChanged(e: any) {
    this.setState({ email: e.target.value });
  }
  private handlePasswordChanged(e: any) {
    let pwdState = "weak";
    if (e.target.value.length > 12) {
      pwdState = "strong";
    } else if (e.target.value.length > 8) {
      pwdState = "medium";
    }
    this.setState({ password: e.target.value, pwdState });
  }
  private handlePassword2Changed(e: any) {
    this.setState({ password2: e.target.value });
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/RegistrationForm.tsx